exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_deliveryPage__3Y4aD {\n  background-color: var(--f7-theme-color);\n}", ""]);

// Exports
exports.locals = {
	"deliveryPage": "styles_deliveryPage__3Y4aD"
};